// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f4f00382","239":"4dc370d9","453":"649c0b75","732":"654eac35"}[chunkId] + ".chunk.js";
};